require('./bootstrap')

// Polyfill de navigator.userAgent para solucionar problema con autorizaciones de ingreso en navegadores antiguos
if (typeof window !== 'undefined') {
    if (!window.navigator) {
        window.navigator = {};
    }
    if (typeof window.navigator.userAgent !== 'string') {
        window.navigator.userAgent = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.3';
    }
}

import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import repo from './repository/repo'
import store from './store/index.js'
import mixins from './mixins'
import VueFirestore from 'vue-firestore'
import VueChatScroll from 'vue-chat-scroll'
import VueClipboard from 'vue-clipboard2'
import VueGoogleCharts from 'vue-google-charts'
import vSelect from 'vue-select'
import VueApexCharts from 'vue-apexcharts'
import { navigationLog } from './analytics/navigation.js'
import Cookies from 'js-cookie'

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.mixin(mixins)
Vue.use(VueFirestore)
Vue.use(VueChatScroll)
Vue.use(VueClipboard)
Vue.use(VueGoogleCharts)
Vue.use(vSelect)
Vue.component('v-select', vSelect)
Vue.prototype.$repo = repo
Vue.prototype.$store = store
Vue.use(VueApexCharts)

import router from './router/router'

router.afterEach(navigationLog)

import App from './components/App'

// Firestore database
// import db from './firebase'
// Vue.prototype.$fdb = db

import moment from 'moment'
moment.locale('es')
Vue.prototype.moment = moment

// Filtros
Vue.filter('datetime', (val) => {
    if (!val) return ''

    let date = moment(val)

    return date.isValid() ? date.format('DD/MM/YYYY HH:mm:ss') : ''
})
Vue.filter('time', (val) => {
    if (!val) return ''

    let date = moment(val)

    return date.isValid() ? date.format('HH:mm:ss') : ''
})
Vue.filter('date', (val) => {
    if (!val) return ''

    let date = moment(val)

    return date.isValid() ? date.format('DD/MM/YYYY') : ''
})
Vue.filter('duration', (val) => {
    if (!val) return ''

    let date = moment(val)

    return date.isValid() ? date.fromNow() : ''
})
Vue.filter('yesno', (val) => {
    return !!val ? 'Si' : 'No'
})

Vue.filter('elipsis', (txt, size) => {
    if (!txt) return ''

    var long = size || 10

    if (txt.toString().length <= long) return txt

    return txt.toString().substring(0, long) + '...'
})
Vue.filter('decimal', (val, spaces = 2) => {
    return parseFloat(val).toFixed(spaces)
})

Vue.filter('percentaje', (val, spaces = 0) => {
    return `${(parseFloat(val) * 100).toFixed(spaces)} %`
})

Vue.filter('currency', function (value) {
    if (typeof value !== 'number') {
        return value
    }
    var formatter = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
    })
    return formatter.format(value)
})

Vue.filter('humanTime', (n) => {
    var num = n
    var hours = num / 60
    var rhours = Math.floor(hours)
    var minutes = (hours - rhours) * 60
    var rminutes = Math.round(minutes)
    return `${rhours} hora${rhours === 1 ? '' : 's'} y ${rminutes} minuto${rminutes === 1 ? '' : 's'}.`
})

Vue.filter('stripHtml', (html) => html.replace(/<[^>]+>/g, ''))

Array.prototype.chunk = function (size) {
    return this.reduce((all, item, i) => {
        const index = Math.floor(i / size)
        all[index] = [].concat(all[index] || [], item)
        return all
    }, [])
}

import AppLogo from '../js/components/layout/Applogo'
import Autocomplete from '@controls/Autocomplete'
import AutocompleteV2 from '@controls/AutocompleteV2'
import Avatar from '@controls/Avatar'
import Button from '@controls/Button'
import ButtonGoBack from '@controls/ButtonGoBack'
import Buttons from '@controls/Buttons'
import ButtonsRight from '@layout/ButtonsRight'
import Camera from '@controls/Camera'
import ConfirmButton from '@controls/ConfirmButton'
import CreateButton from '@controls/CreateButton'
import DataTable from '@controls/DataTable'
import DynamicField from '@controls/DynamicField'
import FluidXs from '@layout/FluidXs'
import FormCheckbox from '@controls/FormCheckbox'
import FormInput from '@controls/FormInput'
import FormRange from '@controls/FormRange'
import FormSelect from '@controls/FormSelect'
import FormTextArea from '@controls/FormTextarea'
import FormYesNo from '@controls/FormYesNo'
import IconButton from '@controls/IconButton'
import ItemTile from '@controls/ItemTile'
import Modal from '@controls/Modal'
import NoBr from '@controls/NoBr'
import SubTitle from '@controls/SubTitle'
import Title from '@controls/Title'
import VecindappBanner from '@layout/VecindappBanner'
import ExcelButton from '@layout/ExcelButton'
import Collapse from '@controls/Collapse'
import Figure from '@controls/Figure'
import Multiselector from '@controls/Multiselector'
import Preloader from '@controls/Preloader'
import FormFile from '@controls/FormFile.vue'
import HomeButton from '@controls/HomeButton.vue'
import HSpace from '@layout/HSpace.vue'
import RadialBar from '@components/charts/RadialBar.vue'
import BarChart from '@components/charts/BarChart.vue'
import DonutChart from '@components/charts/DonutChart.vue'
import LineChart from './components/charts/LineChart.vue'
import NumberCard from '@components/charts/NumberCard.vue'
import LoadingOverlay from '@layout/LoadingOverlay.vue'

Vue.component('app-autocomplete-v2', AutocompleteV2)
Vue.component('app-autocomplete', Autocomplete)
Vue.component('app-avatar', Avatar)
Vue.component('app-btn-back', ButtonGoBack)
Vue.component('app-btn-confirm', ConfirmButton)
Vue.component('app-btn-create', CreateButton)
Vue.component('app-button', Button)
Vue.component('app-buttons-right', ButtonsRight)
Vue.component('app-buttons', Buttons)
Vue.component('app-camera', Camera)
Vue.component('app-data-table', DataTable)
Vue.component('app-dynamic-field', DynamicField)
Vue.component('app-fluid-xs', FluidXs)
Vue.component('app-form-checkbox', FormCheckbox)
Vue.component('app-form-input', FormInput)
Vue.component('app-form-range', FormRange)
Vue.component('app-form-select', FormSelect)
Vue.component('app-form-text-area', FormTextArea)
Vue.component('app-form-yesno', FormYesNo)
Vue.component('app-icon-button', IconButton)
Vue.component('app-item-tile', ItemTile)
Vue.component('app-logo', AppLogo)
Vue.component('app-modal', Modal)
Vue.component('app-no-br', NoBr)
Vue.component('app-sub-title', SubTitle)
Vue.component('app-title', Title)
Vue.component('app-vecindapp-banner', VecindappBanner)
Vue.component('app-btn-excel', ExcelButton)
Vue.component('app-collapse', Collapse)
Vue.component('app-figure', Figure)
Vue.component('app-multi-selector', Multiselector)
Vue.component('app-preloader', Preloader)
Vue.component('app-form-file', FormFile)
Vue.component('app-btn-home', HomeButton)
Vue.component('app-h-space', HSpace)
Vue.component('app-apexchart', VueApexCharts)
Vue.component('app-radialbar-chart', RadialBar)
Vue.component('app-bar-chart', BarChart)
Vue.component('app-donut-chart', DonutChart)
Vue.component('app-number-card', NumberCard)
Vue.component('app-line-chart', LineChart)
Vue.component('app-loading-overlay', LoadingOverlay)
Array.prototype.pluck = function (field) {
    return this.map((item) => (field in item ? item[field] : ''))
}

Array.prototype.pluckText = function (field, glue = ', ') {
    return this.pluck(field).join(glue)
}

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
let EventBus = new Vue()
// Asignar bus de eventos globales
Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function () {
            return EventBus
        },
    },
})

const app = new Vue({
    el: '#app',
    router,
    store,
    components: {
        app: App,
    },
    data: {
        version: null,
        loadingOverlay: null,
    },
    methods: {
        async checkVersion() {
            const {data} = await this.$repo.get('version')
            const cookieVersion = parseInt(Cookies.get('appversion') ?? 0)
            if (cookieVersion !== data) {
                // Mostrar la ventana de carga  
                this.showLoadingOverlay();  
                // Set cookie appversion for 30 days
                Cookies.set('appversion', data, { expires: 30 })
                window.location.reload(true)
            }
        },
        showLoadingOverlay() {
            if (!this.loadingOverlay) {  
                this.loadingOverlay = new Vue({  
                    render: h => h(LoadingOverlay)  
                }).$mount();  
                document.body.appendChild(this.loadingOverlay.$el);  
            } else {  
                this.loadingOverlay.$children[0].showOverlay();  
            } 
        },
        hideLoadingOverlay() {
            if (this.loadingOverlay) {  
                this.loadingOverlay.$children[0].hideOverlay();  
            } 
        },
    },
    created() {
        this.checkVersion()
    },
})
